import React from 'react'
import { Link } from 'common-tools/ReachRouter'
import _ from 'common-tools/LodashHelper'
import { ah, ReduxWrapper, compose } from 'common-data/datahelpers'
import { Storage, StorageKeys } from 'common-tools/StorageHelper'
import clsx from 'clsx'

// const getClassNames = (isCurrent, isPartiallyCurrent, exact, className, activeClassName) => {
//   let cls = [
//     className
//   ]
//   if (exact) {
//     if (isCurrent) {
//       cls.push(activeClassName)
//     }
//   } else if (isCurrent || isPartiallyCurrent) {
//     cls.push(activeClassName)
//   }
//   return _.join(cls, ' ')
// }

const RouteLinkPlain = ({ 'data-tid': testId = '', children, stopBubbleClicks, activeClassName, className, exact, addLayoutContentBreadCrumbKey, breadCrumbKey, showConfirm, ...rest }) => {
  const lnk = <Link onClick={(e) => {
    const confirmAbandon = Storage.Get(StorageKeys.ConfirmAbandonChanges)
    if (confirmAbandon) {
      const caller = e.currentTarget
      e.preventDefault()
      e.stopPropagation()
      e.nativeEvent.stopImmediatePropagation()
      showConfirm(confirmAbandon, () => {
        Storage.Clear(StorageKeys.ConfirmAbandonChanges)
        if (caller) {
          caller.click()
        }
      })
    }
  }} {...rest} getProps={({ isCurrent, isPartiallyCurrent }) => {
    return {
      'data-tid': testId,
      className: clsx(className, (isCurrent || isPartiallyCurrent) && activeClassName)
    }
  }} >{children}</Link>

  if (stopBubbleClicks) {
    return <span onClick={(e) => {
      e.preventDefault()
      e.stopPropagation()
      e.nativeEvent.stopImmediatePropagation()
      if (_.isArray(breadCrumbKey)) {
        _.each(breadCrumbKey, (bk) => {
          addLayoutContentBreadCrumbKey(bk.key, bk.value, bk.disabled)
        })
      } else if (breadCrumbKey) {
        addLayoutContentBreadCrumbKey(breadCrumbKey.key, breadCrumbKey.value, breadCrumbKey.disabled)
      }
    }}>
      {lnk}
    </span>
  } else {
    return lnk
  }
}

export const RouteLink = compose(
  ReduxWrapper([
  ], [
    ah.addLayoutContentBreadCrumbKey,
    ah.showConfirm
  ])
)(RouteLinkPlain)
